var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" File: "+_vm._s(_vm.currentFile)+" "),_c('b-button',{staticClass:"m-1",staticStyle:{"font-size":"smaller"},on:{"click":_vm.pickFile}},[_vm._v("Load")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }